import { bandWidthDateFormatter, quarterDateFormatter } from 'src/utils';
import { sortArrayByDate } from 'src/utils/dates/sortArrayByDate';
import { CongestionReportsResponse } from '../hooks/useCongestionReports';
import { FALLBACK_VALUE } from '../constant';

export const getLatestBandWidthDate = (reports: CongestionReportsResponse[]) => {
  const dates = reports.map((report) => {
    return {
      bandWidthStartDate: report.resolvedStartDate ?? '',
      bandWidthEndDate: report.resolvedDate ?? '',
    };
  });

  const sortedDates = sortArrayByDate<
    { bandWidthStartDate: string; bandWidthEndDate: string },
    'bandWidthStartDate'
  >(dates, 'bandWidthStartDate');

  const latestBandWidthDate = sortedDates[0];

  return latestBandWidthDate
    ? bandWidthDateFormatter({
        bandWidthStartDate: latestBandWidthDate.bandWidthStartDate,
        bandWidthEndDate: latestBandWidthDate.bandWidthEndDate,
        callbackFunction: (date) => quarterDateFormatter(date, FALLBACK_VALUE),
      })
    : undefined;
};
